import Drawer, { type DrawerProps } from '@liquidweb-dev/undercurrent/Drawer';
import Header from './Header';

export interface WrapperProps extends Omit<DrawerProps, 'onClose'> {
	onClose: () => void;
}

const Wrapper = ({ onClose, children, ...drawerProps }: WrapperProps) => {
	return (
		<Drawer anchor="right" onClose={onClose} {...drawerProps}>
			<Header onClose={onClose} />
			{children}
		</Drawer>
	);
};

export default Wrapper;
